/* SCRIPTS */
jQuery(function ($) {
    $('.box-share .btn-share').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.buttons-share').slideToggle();
    });
    $('.box-share').mouseleave(function (e) {
        e.preventDefault();
        $(this).children('.buttons-share').slideUp();
    });

    $('.mask-date').mask('00/00/0000');
    $('.mask-time').mask('00:00:00');
    $('.mask-cep').mask('00000-000');    
    $('.mask-cpf').mask('000.000.000-00', { reverse: true });
    $('.mask-cnpj').mask('00.000.000/0000-00', { reverse: true });
    $('.mask-money').mask('000.000.000.000.000,00', { reverse: true });

    var TELMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    TELOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(TELMaskBehavior.apply({}, arguments), options);
        }
    };

    $('.mask-tel').mask(TELMaskBehavior, TELOptions);

    $('.mask-input-cpf input').mask('000.000.000-00');
    $('.mask-input-cep input').mask('00000-000');
    $('.mask-input-tel input').mask(TELMaskBehavior, TELOptions);

    $('#btn-open-mobile').on('click', function (e) {
        e.preventDefault;
        $('#nav-header').css('left', 0);
    });
    $('#btn-close-mobile').on('click', function (e) {
        e.preventDefault;
        $('#nav-header').css('left', -350);
    });

    if($('#sidebar-info').length > 0){

        var sidebarsize = $('#sidebar-info').outerHeight();
        var sidebaroffset = $('#sidebar-info').offset();
        var sidebarposition = sidebarsize + sidebaroffset.top;
    
        $(window).scroll(function(){
            
            var windowheight = $(window).height();
            var scrollsize = $(window).scrollTop();
            var windowposition = windowheight + scrollsize;
    
            if( windowposition > sidebarposition ){
                $('#sidebar-info .info-about').hide();
                $('#sidebar-info .course-info-sidebar').addClass('sticky-top');
            }else{
                $('#sidebar-info .info-about').show();
                $('#sidebar-info .course-info-sidebar').removeClass('sticky-top');
            }
            
    
        });
    }

});